import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '@/features/i18n/I18nProvider';
import { LocaleToggle } from '@/features/i18n/LocaleToggle';

export function MarketingNav() {
  const [open, setOpen] = useState(false);
  const { t } = useI18n();
  const location = useLocation();
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!open) return;

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    const onPointer = (e: MouseEvent | TouchEvent) => {
      const target = e.target as Node | null;
      if (headerRef.current && target && !headerRef.current.contains(target)) {
        setOpen(false);
      }
    };

    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onPointer);
    document.addEventListener('touchstart', onPointer);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('touchstart', onPointer);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  return (
    <header className={`mkt-nav${open ? ' is-menu-open' : ''}`} ref={headerRef}>
      <Link to="/" className="mkt-logo" aria-label={t('mkt.nav.homeAria')} onClick={() => setOpen(false)}>
        <img src="/logo-isbd.png" alt="ISBD" />
      </Link>
      <div className="mkt-nav-actions">
        <LocaleToggle className="mkt-locale-toggle" />
        <button
          type="button"
          className="mkt-menu-btn"
          aria-expanded={open}
          aria-controls="mkt-nav-links"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Fermer' : t('mkt.nav.menu')}
        </button>
      </div>
      {open ? (
        <button
          type="button"
          className="mkt-menu-backdrop"
          aria-label="Fermer le menu"
          onClick={() => setOpen(false)}
        />
      ) : null}
      <nav id="mkt-nav-links" className={open ? 'is-open' : undefined}>
        <a href="/#parcours" onClick={() => setOpen(false)}>
          {t('mkt.nav.parcours')}
        </a>
        <a href="/#offres" onClick={() => setOpen(false)}>
          {t('mkt.nav.offres')}
        </a>
        <Link to="/marketplace" onClick={() => setOpen(false)}>
          {t('mkt.nav.marketplace')}
        </Link>
        <a href="/#equipe" onClick={() => setOpen(false)}>
          {t('mkt.nav.equipe')}
        </a>
        <Link to="/contact" onClick={() => setOpen(false)}>
          {t('mkt.nav.contact')}
        </Link>
        <LocaleToggle className="mkt-locale-toggle mkt-locale-toggle-desktop" />
        <Link to="/connexion" className="btn btn-ghost" onClick={() => setOpen(false)}>
          {t('mkt.nav.login')}
        </Link>
        <Link to="/inscription" className="btn btn-accent" onClick={() => setOpen(false)}>
          {t('mkt.nav.register')}
        </Link>
      </nav>
    </header>
  );
}
